import React from 'react';

const PartnerTableStatusCell = ({ meta }) => {
  if (!meta?.label) {
    return <td className="partner-table-status-cell">-</td>;
  }

  const tooltip = meta.title || meta.label;

  return (
    <td className="partner-table-status-cell">
      <div className="partner-table-status-wrap">
        <span
          className={`partner-status-pill ${meta.className}`}
          title={tooltip || undefined}
          aria-label={tooltip || undefined}
        >
          <span className="partner-status-dot" aria-hidden="true" />
          <span className="partner-status-label">{meta.label}</span>
        </span>
      </div>
    </td>
  );
};

export default PartnerTableStatusCell;
